import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage: React.FC = () => (
  <div className="min-h-screen flex flex-col items-center justify-center px-6 text-center">
    <p className="text-sm text-slate-500 mb-2">404 / Not Found</p>
    <h1 className="text-2xl font-bold text-slate-900 mb-2">ページが見つかりません</h1>
    <p className="text-sm text-slate-600 max-w-md">
      共有URLが期限切れか、削除された可能性があります。共有された方にご確認ください。
    </p>
    <Link to="/" className="mt-6 text-sm text-blue-600 hover:underline">トップへ戻る</Link>
  </div>
);

export default NotFoundPage;
